<template>
    <div class="mt_140">
    
        <ccMenu v-show="logado == 0" ref="cc_menu" v-bind:posicao=2></ccMenu>
        <ccMenu v-show="logado == 1" ref="cc_menu" v-bind:posicao=3></ccMenu>
        <ccLoading v-show="loading" ref="cc_loading"></ccLoading>
    
        <div class="container">
        <div class="row">
        <div class="col-md-12 ps-4 p-2" style="background: #171A26 0% 0% no-repeat padding-box; border-radius: 17px 17px 0px 0px;">
    
          <div class="row">    
              
              <div class="col-md-12" id="real_time">
                
                  <div class="row">
                    <div class="col-md-12 pt-3" style="background: #FFFFFF08 0% 0% no-repeat padding-box; border-radius: 12px 12px 0px 0px;">
                        <div class="text_15 text_bold text_branco text-center"> AUDITORIA TORNEIO SOKKERDUEL</div>
                        <div class="text_14 text_branco"> ID Torneio: {{torneio.id}}</div>
                        <div class="text_14 text_branco"> {{torneio.nome}} | {{torneio.prize}}</div>
                        <div class="text_14 text_branco"> Data de Início: {{timestamp_dataBR(torneio.dt_inicio_timestamp,5)}}</div>
                        <br>
                        <div class="text_14 text_branco pb-3"> Lista de palpites</div>
      
                        <div class="row">
                          <div class="col-md-12">
      
                            <div class="caixa_aposta">
                              <table class="table tabela">
                                <thead>
                                  <tr>
                                    <th style="width:10%">ID Palpite</th>                                    
                                    <th>Username</th>
                                    <th>Time Local</th>
                                    <th>Time Visitante</th>
                                    <th>Mercado</th>
                                    <th class="text-center">Opção</th>
                                    <th class="text-center">Pontuação</th>                                  
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="aposta of apostas">
                                    <td>{{aposta.palpite_id}}</td>
                                    <td> <span style="font-size:10px;">{{aposta.username}} {{aposta.entrada==1?"":"("+aposta.entrada+")"}}</span> </td>
                                    <td>{{aposta.time1}}</td>
                                    <td>{{aposta.time2}}</td>
                                    <td>{{aposta.mercado}}</td>
                                    <td class="text-center">{{aposta.opcao}}</td>
                                    <td class="text-center">{{aposta.ponto}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
      
                          </div>
                        </div>                        
      
                        <div class="pb-2">
                          <div class="row">
                            <div class="col-md-4">          
                              <router-link
                                :to="{ name: 'minha_aposta_ws_redis', params: { torneio_id: torneio.id } }"
                                type="button" class="btn btn-outline-secondary btn-sm w-100 text_bold"
                              >                    
                                Voltar
                              </router-link>
                            </div>
                            <div class="col-md-4 offset-4">
                              <button @click="salvarTabela" type="button" class="btn btn-outline-warning w-100 btn-sm text_12"> SALVAR TABELA CSV</button>
                            </div>
                          </div>
                        </div>

                    </div>
                  </div>                
    
              </div>

          </div>
    
        </div>
        </div>
        </div>
    
        <ccFooter></ccFooter>
    </div>
    </template>
    
    <script>
    import axios from 'axios'    
    import ccMenu from '../layout/menu.vue'
    import ccFooter from '../layout/footer.vue'
    import ccJogoResultado from '../cc_geral/cc_jogo_resultado.vue'
    import ccLoading from '../cc_geral/cc_loading.vue'
    import ccDetalheTorneio from '../cc_geral/cc_detalhe_torneio_modal.vue'
    import { RouterLink } from 'vue-router'
    
    export default {
      data () {
        return {
          base_url_api: process.env.BASE_URL_API,
          user: {},
          loading: false,
          errors: [],
          apostas: [],
          torneio_id_sec: 0,
          torneio: {},
        }
      },
    
      components: { ccMenu, ccFooter, ccJogoResultado, ccLoading, ccDetalheTorneio, ccFooter, RouterLink },
    
      created(){
        document.title = 'Meu Torneio - SokkerDuel';
    
        localStorage.setItem("base_url_api_mobile", this.base_url_api);
      },
    
      mounted(){          
          
        this.torneio_id_sec = this.$route.params.torneio_id;
        
        document.title = 'Torneio: Auditoria - SokkerDuel';
    
        let a = JSON.parse(localStorage.getItem("user"));
    
        if (a == null){
          this.user = {}
          this.logado = 0
        }else{
          this.user = a
          this.logado = 1
        }
    
        this.get_torneio()
      },
    
      methods: {            
          
          async get_torneio(){

              this.loading = true
              var header = {'headers': {'x-access-token': this.user.access_token, }};            
              await axios.get(this.base_url_api+'torneio/find_id/'+this.torneio_id_sec, header)
              .then(response => {
        
                  this.loading = false
                  this.torneio = response.data.resp.torneio

                        
                          this.loading = true
                          var header = {'headers': {'x-access-token': this.user.access_token, }};
                          axios.get(this.base_url_api+'torneio/'+this.torneio_id_sec+'/auditoria', header)                        
                          .then(response => {
                    
                            this.loading = false
                            this.apostas = response.data
                            
                          })
                          .catch(e => {
                            this.errors.push(e);
                            this.loading = false
                          });                        

                
              })
              .catch(e => {
                this.errors.push(e);
                this.loading = false
              });

          },

          salvarTabela() {
              // Lógica para salvar a tabela em um arquivo
              // Por exemplo, você pode usar a biblioteca FileSaver.js

              import('file-saver').then((FileSaver) => {
                const blob = new Blob([this.gerarConteudoCSV()], { type: 'text/csv;charset=utf-8' });
                FileSaver.saveAs(blob, 'torneio' + this.torneio.id + '.csv');
              });
          },

          gerarConteudoCSV() {
              // Lógica para gerar o conteúdo do CSV a partir dos dados da tabela
              // Aqui você precisa construir uma string CSV com os dados da tabela
              // Exemplo simples (adaptar conforme a estrutura dos seus dados):
              const headers = ['ID Palpite', 'Id Usuário', 'Usuário', 'Time Local', 'Time Visitante', 'Mercado', 'Opção', 'Pontuação'];
              const linhas = this.apostas.map(aposta => Object.values(aposta).join(','));
              return [headers.join(','), ...linhas].join('\n');
          },



    
      },
    

    }
    </script>
    
    
    <style scoped>
    
      input.form-control{
        background: #36394580 0% 0% no-repeat padding-box;
        border: 2px solid #3E3E3E80;
        border-radius: 5px;
        margin-bottom:10px;
        background-image: url("../../assets/image/lupa.svg");
        background-size: 20px;
        background-position: right;
        background-repeat: no-repeat;
      }
    
      input.form-control::placeholder {
        color: #ffffff80;
        font-size: 13px;
      }
    
      /* GERAL : FIM -----------  */
    
      /* CARACTERISTICAS DO TORNEIO E SUAS APOSTAS ----------------*/
    
      .box1{
        background: #171A28 0% 0% no-repeat padding-box;
        border-radius: 17px 17px 0px 0px;
        color:  #fff;
        font-size: 13px;
      }
    
      .box1 .coluna_tonament_name{
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 12px 12px 0px 0px;
        padding: 10px;
        margin-top: 10px;
        font-size: 13px;
      }
    
      .box1 .divisao_tracejada{
        border: 1px dashed #707070;
        margin: 10px 0 10px 0;
      }
    
      .caixa_aposta{
        height: 430px;
        overflow:auto;
      }
    
    
      .tabela{
        color:  #ffffff80;
        font-size: 10px;
      }
    
      .tabela thead th {
        color: #ffffff;
        border-bottom: 0px;
        border: 0;
        font-size: 10px;
      }
    
      .tabela th, .tabela td {
        border-bottom: 0px;
        cursor: pointer;
        padding: 0.2rem;
        border: 0;
      }
    
      .tabela tr:hover{
        color: greenyellow;
        background-color: rgba(255, 255, 255, 0.14);
      }
    
      .tabela .escolheu_aposta{
        background-color: rgba(92, 183, 13, 0.3);
      }
    
      .tabela .disabled {
        pointer-events: none;
        cursor: default;
        opacity: 0.6;
      }
    
      .page-link{
        border: 0;
        background-color: transparent;
        color:  greenyellow;
        font-family: myFontBold;
      }
    
      .paginas{
        padding-top: 5px;
        color: #444;
      }
    
      .only_true{
        color: greenyellow;
      }
    
      .only_false{
        color: #ffffff80;
      }
    
    
    
      /* CARACTERISTICAS DO TORNEIO E SUAS APOSTAS : FIM ----------------*/
    
      #box_mercado_opcoes{
        height: 750px;
      }
    
      #box_mercado_opcoes .apagado{
        opacity: 1;
      }
    
      #box_mercado_opcoes .acesso{
        opacity: 1;
      }
    
      #box_mercado_opcoes .opcao{
        background-color: #101324;
        font-size: 11px !important;
      }
    
      #box_mercado_opcoes .opcao .imagem{
        width: 33px;
        height: 33px;
      }
    
      #box_mercado_opcoes .opcao .placar{
        padding-top: 13px;
        font-size: 24px;
        font-weight: bolder;
      }
    
      #box_mercado_opcoes .opcao.pontos {
      text-align: center;
      }
    
      #box_mercado_opcoes .opcao .aovivo_vermelho{
        color: red;
      }
    
      #box_mercado_opcoes .opcao .aovivo_branco{
        color: #ffffff;
      }
    
    
    
      /* AZULADO - aguardando*/
      #box_mercado_opcoes .opcao.azulado{
        background: #99AEE41A;
        color: #99AEE480;
      }
      #box_mercado_opcoes .azulado_faixa{
        margin-top: 4px;
        margin-bottom: 4px;
        padding: 4px 0 4px 0;
        background-color: #99AEE426;
        color: #99AEE480;
      }
      /*AZULADO - FIM */
    
    
      /* VERDE - positivo */
      #box_mercado_opcoes .opcao.verde{
        background: #5CB70D33;
        color: #5CB70D;
      }
    
      #box_mercado_opcoes .verde_faixa{
        margin-top: 4px;
        margin-bottom: 4px;
        padding: 4px 0 4px 0;
        background-color: rgba(92, 183, 13, 0.2);
        color: #5CB70D;
      }
      /* VERDE - FIM */
    
    
      #box_mercado_opcoes .opcao.vermelho{
      background-color: rgba(255, 51, 0, 0.2);
      color: #FF3300;
      }
      #box_mercado_opcoes .vermelho_faixa{
        margin-top: 4px;
        margin-bottom: 4px;
        padding: 4px 0 4px 0;
        background-color: #FF33001A;
      }
    
    
    
      /* CINZA */
      #box_mercado_opcoes .opcao.cinza{
        background-color: #FFFFFF0D;
        color: FFFFFF4D;
      }
      #box_mercado_opcoes .cinza-faixa{
        background-color: #FFFFFF1A;
        margin-top: 4px;
        margin-bottom: 4px;
        padding: 4px 0 4px 0;
      }
      /* CINZA - FIM */
    
    
    
      /* RSULTADOS ----------------------------- */
    
      .btn_detalhes{
        width: 115px;
        height: 28px;
        border-radius: 10px;
        font-size: 12px;
        background-color: rgba(153, 173, 228, 0.3);
        text-align: center;
        padding-top: 5px;
        float: right;
      }
    
      .btn_estatisticas{
        width: 115px;
        height: 28px;
        border-radius: 10px;
        font-size: 12px;
        background-color: transparent;
        text-align: center;
        padding-top: 5px;
        float: left;
        border: solid 1px rgba(153, 173, 228, 0.3);
      }
    
    
    </style>


// WEBPACK FOOTER //
// src/components/torneio_auditoria/auditoria.vue